import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner, Badge } from "reactstrap";
import moment from "moment";
import api from "../../../../Api.js";

const actionLabels = {
  create: "Criação",
  update: "Edição",
  delete: "Remoção"
};

const UserEditHistory = ({ isOpen, userId, userName, toggle }) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (isOpen && userId) {
      (async () => {
        setLoading(true);
        try {
          const res = await api.getUserUpdateHistory(userId);
          setHistory(res.data);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      setHistory([]);
    }
  }, [isOpen, userId]);

  // conta editores únicos
  const uniqueEditorsCount = new Set(
    history.map(h => `${h.editor_name} ${h.editor_lastname}`)
  ).size;

  const formatChangeDetails = details => {
    if (!details) return null;
    try {
      const changes = JSON.parse(details);
      const keys = Object.keys(changes).filter(
        k => String(changes[k].from) !== String(changes[k].to)
      );
      if (!keys.length) return null;

      return (
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {keys.map(field => {
            // Se from/to forem objetos, converta-os em string
            const fromValue = typeof changes[field].from === "object"
              ? JSON.stringify(changes[field].from)
              : String(changes[field].from);

            const toValue = typeof changes[field].to === "object"
              ? JSON.stringify(changes[field].to)
              : String(changes[field].to);

            return (
              <li key={field}>
                <Badge color="info">{field}</Badge>{" "}
                De “{fromValue}” para “{toValue}”
              </li>
            );
          })}
        </ul>
      );
    } catch {
      return null;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <div className="modal-header">
        <h5 className="modal-title">
          Histórico de Edições – {userName} ({uniqueEditorsCount}{" "}
          {uniqueEditorsCount > 1 ? "editores" : "editor"})
        </h5>
        <button className="close" onClick={toggle}>
          <span>×</span>
        </button>
      </div>
      <div className="modal-body">
        {loading ? (
          <div className="text-center p-4">
            <Spinner color="primary" />
            <p className="mt-2">Carregando histórico...</p>
          </div>
        ) : history.length === 0 ? (
          <p className="text-center">Nenhum registro encontrado.</p>
        ) : (
          <Table striped responsive>
            <thead>
              <tr>
                <th>Editor</th>
                <th>Data</th>
                <th>Ação</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              {history
                .filter(item => item.action === "update")
                .map(item => (
                  <tr key={item.id}>
                    <td>
                      <Badge color="info">
                        {item.editor_name} {item.editor_lastname}
                      </Badge>
                    </td>
                    <td>{moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                    <td>
                      <Badge color={
                        item.action === "delete" ? "danger" :
                        item.action === "create" ? "success" : "warning"
                      }>
                        {actionLabels[item.action] || item.action}
                      </Badge>
                    </td>
                    <td>
                      {item.change_description}
                      {formatChangeDetails(item.change_details)}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
        )}
      </div>
      <div className="modal-footer">
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </div>
    </Modal>
  );
};

export default UserEditHistory;